module.exports = __webpack_public_path__ + "static/media/GitHub_Logo_White.064ace47.png";